import { Text, View } from '@react-pdf/renderer';

import { ITagOption } from '@/features/fermentation/utils/tags-label-mapper';
import i18n from '@/locales/i18n';

export const getFermentationTags = (tags: ITagOption[]) => {
  return (
    <View style={{ marginBottom: 30, marginTop: 30 }}>
      {tags.map((row) => (
        <View
          key={row.label}
          style={{
            padding: 5,
            display: 'flex',
            marginVertical: 1,
            flexDirection: 'row',
            backgroundColor: '#e2e8f0',
          }}
        >
          <View style={{ width: 150 }}>
            <Text>{i18n.t(row.label) as string}</Text>
          </View>
          <View>
            <Text style={{ fontWeight: 200 }}>{row.value}</Text>
          </View>
        </View>
      ))}
    </View>
  );
};
